"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoriteFullFragmentDoc = void 0;
const client_1 = require("@apollo/client");
const GeoObject_generated_1 = require("./GeoObject.generated");
exports.FavoriteFullFragmentDoc = client_1.gql `
    fragment FavoriteFull on Favorite {
  Id
  Comment
  GeoObject {
    ...GeoObjectFull
  }
}
    ${GeoObject_generated_1.GeoObjectFullFragmentDoc}`;
//# sourceMappingURL=Favorite.generated.js.map